"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MenuGroupHeader: function() {
        return _index.MenuGroupHeader;
    },
    menuGroupHeaderClassNames: function() {
        return _index.menuGroupHeaderClassNames;
    },
    renderMenuGroupHeader_unstable: function() {
        return _index.renderMenuGroupHeader_unstable;
    },
    useMenuGroupHeaderStyles_unstable: function() {
        return _index.useMenuGroupHeaderStyles_unstable;
    },
    useMenuGroupHeader_unstable: function() {
        return _index.useMenuGroupHeader_unstable;
    }
});
const _index = require("./components/MenuGroupHeader/index");
